import { TIMER_START, TIMER_STOP, TIMER_TICK } from '../actions/types';

export default function (state = Date.now(), action) {
  switch (action.type) {
    case TIMER_TICK:
      return action.payload;
    case TIMER_START:
    case TIMER_STOP:
    default:
      return state;
  }
}
